import { Ref } from '@nuxtjs/composition-api';

import ISlide from '~/components/ui/types/ISlide';

const getSlides = (zdjecia: Ref<string[]>): ISlide[] => (!zdjecia.value ? [] : zdjecia.value.map((url: string) => ({ imageUrl: url, alt: url })));
export default getSlides;
